/* Perfectly Pure • Native Shopify theme • No third party runtime. */
(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('ThemeConfig')?.textContent || '{}');
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const announce = (message) => { const node = $('#StatusMessage'); if (node) node.textContent = message; };
  const errorText = (response) => typeof response.description === 'string' ? response.description : typeof response.message === 'string' ? response.message : config.strings?.error;
  let focusBeforeDialog;
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    focusBeforeDialog = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('dialog-open');
    requestAnimationFrame(() => (dialog.querySelector('input:not([type="hidden"]),button,a[href]') || dialog).focus());
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    document.documentElement.classList.remove('dialog-open');
    if (focusBeforeDialog?.isConnected) focusBeforeDialog.focus();
  }
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-dialog-close]');
    if (close) closeDialog(close.closest('dialog'));
    const search = event.target.closest('[data-search-open]');
    if (search && typeof HTMLDialogElement !== 'undefined') { event.preventDefault(); openDialog($('#SearchDialog'), search); }
    const cart = event.target.closest('[data-cart-open]');
    if (cart && config.cartDrawer && typeof HTMLDialogElement !== 'undefined') { event.preventDefault(); openDialog($('#CartDrawer'), cart); }
    if (event.target.matches('dialog[open]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(event.target);
    }
    const oneTime = event.target.closest('[data-one-time]');
    if (oneTime) {
      const form = oneTime.closest('form');
      const once = $('[data-plan-variant]:not([hidden]) [data-plan-option][value=""]', form);
      if (once) { once.checked = true; once.dispatchEvent(new Event('change', { bubbles: true })); form.requestSubmit($('[data-add-button]', form)); }
    }
    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) showMedia(mediaButton.closest('[data-gallery]'), mediaButton.dataset.mediaTarget);
    const grid = event.target.closest('[data-grid-columns]');
    if (grid) {
      const section = grid.closest('.collection-page');
      $('[data-collection-grid]', section).style.setProperty('--columns', grid.dataset.gridColumns);
      $$('[data-grid-columns]', section).forEach(button => button.setAttribute('aria-pressed', String(button === grid)));
    }
  });
  document.addEventListener('cancel', event => { if (event.target.matches('dialog')) { event.preventDefault(); closeDialog(event.target); } }, true);

  if (!customElements.get('quantity-control')) customElements.define('quantity-control', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-step]'); if (!button) return;
        const input = $('input', this), old = input.value;
        const step = Number(input.step) || 1, min = Number(input.min || 0), max = input.max ? Number(input.max) : Infinity;
        input.value = String(Math.min(max, Math.max(min, (Number(input.value) || min) + Number(button.dataset.step) * step)));
        if (input.value !== old) input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  function showMedia(gallery, id) {
    if (!gallery || !id || !$(`[data-media-id="${CSS.escape(String(id))}"]`, gallery)) return;
    $$('[data-media-id]', gallery).forEach(media => {
      media.hidden = media.dataset.mediaId !== String(id);
      if (media.hidden) $$('video', media).forEach(video => video.pause());
    });
    $$('[data-media-target]', gallery).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
  }

  function updateProduct(form, variantChanged = false) {
    const select = $('[data-variant-select]', form); if (!select) return;
    const variant = select.selectedOptions[0], details = form.closest('[data-product-section]');
    if (!variant) return;
    const available = variant.dataset.available === 'true';
    $$('[data-plan-variant]', form).forEach(panel => { panel.hidden = panel.dataset.planVariant !== variant.value; panel.disabled = panel.hidden; });
    const panel = $('[data-plan-variant]:not([hidden])', form);
    const choice = $('[data-plan-option]:checked', panel || document.createElement('div'));
    const hidden = $('[data-selling-plan]', form);
    if (hidden) { hidden.value = choice?.value || ''; hidden.disabled = !hidden.value; }
    const price = choice?.dataset.price || variant.dataset.price;
    const rawPrice = Number(choice?.dataset.rawPrice || variant.dataset.rawPrice);
    $('[data-product-price]', details).textContent = price;
    const compare = $('[data-compare-price]', details);
    compare.hidden = !(Number(variant.dataset.rawCompare) > rawPrice);
    compare.textContent = variant.dataset.compare;
    const add = $('[data-add-button]', form);
    add.disabled = !available;
    add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
    const once = $('[data-one-time]', form);
    if (once) { once.hidden = variant.dataset.requiresPlan === 'true' || !panel; once.disabled = !available; }
    const quantity = $('input[name="quantity"]', form);
    quantity.min = variant.dataset.min || '1'; quantity.step = variant.dataset.step || '1';
    if (variant.dataset.max) quantity.max = variant.dataset.max; else quantity.removeAttribute('max');
    if (variantChanged) {
      quantity.value = quantity.min;
      const url = new URL(location.href); url.searchParams.set('variant', variant.value);
      if (choice?.value) url.searchParams.set('selling_plan', choice.value); else url.searchParams.delete('selling_plan');
      history.replaceState({}, '', url);
      showMedia($('[data-gallery]', details), variant.dataset.mediaId);
    }
  }
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-product-form]');
    if (form && event.target.matches('[data-variant-select],[data-plan-option]')) updateProduct(form, event.target.matches('[data-variant-select]'));
    const sort = event.target.closest('[data-sort-form]'); if (sort && event.target.matches('select')) sort.requestSubmit();
    const cartQuantity = event.target.closest('[data-cart-drawer] input[data-line-key]');
    if (cartQuantity) changeCart(cartQuantity.dataset.lineKey, Number(cartQuantity.value), cartQuantity);
  });

  function setCartContent(sectionHTML) {
    if (!sectionHTML) return false;
    const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
    const next = $('[data-cart-drawer-content]', parsed), current = $('[data-cart-drawer-content]');
    if (!next || !current) return false;
    current.replaceWith(next); return true;
  }
  async function refreshCart() {
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(`${config.routes.cart}?section_id=cart-drawer`, { credentials: 'same-origin' }),
      fetch(`${config.routes.cart}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error(config.strings.error);
    const cart = await cartResponse.json(); setCartContent(await sectionResponse.text()); updateCartCount(cart.item_count);
  }
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(node => { node.textContent = count; node.hidden = count === 0; });
    $$('[data-cart-open]').forEach(node => node.setAttribute('aria-label', `Bag (${count})`));
  }

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-product-form],form[data-plan-form]');
    if (!form || !window.fetch || !config.routes) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    if (form.matches('[data-product-form]') && form.dataset.nativeSubscriptions === 'theme') updateProduct(form);
    const error = $('[data-product-error]', form), button = event.submitter || $('button[type="submit"]', form);
    const label = button.textContent; if (error) error.hidden = true;
    form.dataset.busy = 'true'; button.disabled = true; button.textContent = config.strings.adding;
    let added = false;
    try {
      const data = new FormData(form); data.append('sections', 'cart-drawer'); data.append('sections_url', location.pathname);
      const response = await fetch(config.routes.cartAdd, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const result = await response.json(); if (!response.ok) throw new Error(errorText(result));
      added = true;
      announce(config.strings.added);
      if (!config.cartDrawer || typeof HTMLDialogElement === 'undefined') { location.assign(config.routes.cart); return; }
      if (!setCartContent(result.sections?.['cart-drawer'])) await refreshCart();
      else {
        const cartResponse = await fetch(`${config.routes.cart}.js`, { credentials: 'same-origin' });
        if (cartResponse.ok) updateCartCount((await cartResponse.json()).item_count);
      }
      openDialog($('#CartDrawer'), button);
    } catch (err) {
      if (added) { location.assign(config.routes.cart); return; }
      if (error) { error.textContent = err.message || config.strings.error; error.hidden = false; } else announce(err.message);
    } finally { form.dataset.busy = 'false'; button.disabled = false; button.textContent = label; if (form.matches('[data-product-form]')) updateProduct(form); }
  });
  let cartBusy = false;
  async function changeCart(key, quantity, source) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    const drawer = $('#CartDrawer'); if (!drawer) return;
    cartBusy = true; drawer.setAttribute('aria-busy', 'true');
    $$('button,input', drawer).forEach(node => { node.disabled = true; });
    const error = $('[data-cart-error]', drawer); if (error) error.hidden = true;
    try {
      const response = await fetch(config.routes.cartChange, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: location.pathname }) });
      const cart = await response.json(); if (!response.ok) throw new Error(errorText(cart));
      if (!setCartContent(cart.sections?.['cart-drawer'])) await refreshCart();
      updateCartCount(cart.item_count); announce('Your bag has been updated.');
      const replacement = $(`input[data-line-key="${CSS.escape(key)}"]`, drawer) || $('[data-dialog-close]', drawer); replacement?.focus();
    } catch (err) {
      try { await refreshCart(); } catch (_) { /* Keep the visible cart and show the error. */ }
      const visibleError = $('[data-cart-error]', drawer); if (visibleError) { visibleError.textContent = err.message || config.strings.error; visibleError.hidden = false; }
      source?.focus();
    } finally { cartBusy = false; drawer.removeAttribute('aria-busy'); $$('button,input', drawer).forEach(node => { node.disabled = false; }); }
  }
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-drawer] [data-remove-item]');
    if (remove) { event.preventDefault(); changeCart(remove.dataset.removeItem, 0, remove); }
  });

  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return; this.loaded = true;
      const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); this.load(); } }, { rootMargin: '300px' });
      observer.observe(this); this.observer = observer;
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async load() {
      try { const response = await fetch(this.dataset.url); if (!response.ok) return; const document = new DOMParser().parseFromString(await response.text(), 'text/html'); const content = document.querySelector('product-recommendations'); if (content?.querySelector('.product-card')) this.innerHTML = content.innerHTML; } catch (_) { /* Recommendations are optional. */ }
    }
  });

  function initialise(root = document) {
    $$('[data-product-form]', root).forEach(form => updateProduct(form));
    $$('[data-footer-details]', root).forEach(details => { details.open = window.matchMedia('(min-width: 750px)').matches; });
    $$('[data-mobile-menu]', root).forEach(details => {
      if (details.dataset.ready) return; details.dataset.ready = 'true';
      const close = () => { details.open = false; $('summary', details).focus(); };
      $('[data-menu-close]', details)?.addEventListener('click', close);
      details.addEventListener('toggle', () => document.documentElement.classList.toggle('menu-open', details.open));
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') close();
        if (event.key === 'Tab' && details.open) {
          const focusables = $$('summary,button,a[href]', details).filter(el => el.getClientRects().length);
          const first = focusables[0], last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  const desktop = window.matchMedia('(min-width: 750px)');
  desktop.addEventListener('change', event => { $$('[data-footer-details]').forEach(details => { details.open = event.matches; }); });
  const wideHeader = window.matchMedia('(min-width: 1100px)');
  wideHeader.addEventListener('change', event => { if (event.matches) $$('[data-mobile-menu]').forEach(details => { details.open = false; }); });
})();
